import React, { useCallback } from 'react';

import { createEcommerceService, createModifyCartEvent, useTrackModifyCartEvent } from '../../../ecommerce';
import { useDeleteGiftPackagingAwaitable } from '../../../services';
import { CartActions, ECartActions, IRemoveGiftPackagingAction } from '../model';

export const useRemoveGiftPackaging = (dispatch: React.Dispatch<CartActions>) => {
  const { request } = useDeleteGiftPackagingAwaitable();
  const trackModifyCartEvent = useTrackModifyCartEvent();

  return useCallback(
    async (data: IRemoveGiftPackagingAction): Promise<boolean> => {
      const deleteGiftPackagingData = (await request())?.data;
      if (deleteGiftPackagingData) {
        dispatch({
          actionType: ECartActions.TOGGLE_GIFT_PACKAGING,
          payload: {
            pricesSummary: deleteGiftPackagingData.pricesSummary,
            giftPackagings: deleteGiftPackagingData.serviceItems.giftPackagings,
          },
        });

        data.service?.forEach((packaging) =>
          trackModifyCartEvent({
            ...createModifyCartEvent(1, 0),
            product: createEcommerceService(packaging),
          }),
        );

        return true;
      }
      return false;
    },
    [request, dispatch, trackModifyCartEvent],
  );
};
